import {
	FETCH_DATA_PENDING,
	FETCH_DATA_ERROR,
	FETCH_TEASERS_SUCCESS,
	FETCH_FACETS_SUCCESS,
	FETCH_PAGINATION_SUCCESS,
	FILTER_BY_CATEGORY,
	FILTER_BY_TOOL,
	FILTER_BY_VALUE,
	FILTER_BY_PAGE,
	ORDER_BY,
	QUERY_VALUE,
} from '../reducers';

import { initialState } from '../store/initialstate';

export function teasersReducer ( state = initialState, action ) {
	switch ( action.type ) {

		/**
		 * DATA LOAD STATUS
		 */
		case FETCH_DATA_PENDING:
			return {
				...state,
				pending: true,
			};

		case FETCH_DATA_ERROR:
			return {
				...state,
				pending: false,
				error: action.error,
			};

		/**
		* FETCH TEASERS
		*/
		case FETCH_TEASERS_SUCCESS:
			let teasers = action.payload;

			return {
				...state,
				pending: false,
				teasers: teasers,
			};

		/**
		 * FETCH & PARSE FACETS
		 */
		case FETCH_FACETS_SUCCESS:
			let tools = action.payload.tools;
			let categories = action.payload.categories;

			return {
				...state,
				categories: categories,
				tools: tools,
				pending: false,
			};

		/**
		* FETCH PAGINATION
		*/
		case FETCH_PAGINATION_SUCCESS:
			return {
				...state,
				totalResults: action.payload.totalResults,
				currentPage: action.payload.currentPage,
				totalPages: action.payload.totalPages,
			}

		/**
		 * FILTER BY
		 */
		case FILTER_BY_VALUE:
			let value = action.payload;

			return {
				...state,
				activeQuery: value,
				error: action.error,
			};

		case QUERY_VALUE:
			let queryValue = action.payload;

			return {
				...state,
				queryValue: queryValue,
			};

		case FILTER_BY_CATEGORY:

			let cats = state.categories;
			let activeCatsIds = action.payload.split(',');

			let newActiveCats = cats.filter(f => activeCatsIds.some(item => parseInt(item) === f.id));

			return {
				...state,
				activeCategories: action.payload,
				activeCategoriesObj: newActiveCats,
				error: action.error,
			};

		case FILTER_BY_TOOL:

			let toolsObj = state.tools;
			let activeToolsIds = action.payload.split(',');

			let newActiveTools = toolsObj.filter(f => activeToolsIds.some(item => parseInt(item) === f.id));

			return {
				...state,
				activeTools: action.payload,
				activeToolsObj: newActiveTools,
				error: action.error,
			};

		case FILTER_BY_PAGE:
			return {
				...state,
				currentPage: action.payload,
				error: action.error,
			};

		case ORDER_BY:
			return {
				...state,
				activeOrderBy: action.payload,
				error: action.error,
			};

		default:
			return state;
	}
}
